import { render, staticRenderFns } from "./cardList2.vue?vue&type=template&id=2552b736&scoped=true"
import script from "./cardList2.vue?vue&type=script&lang=js"
export * from "./cardList2.vue?vue&type=script&lang=js"
import style0 from "./cardList2.vue?vue&type=style&index=0&id=2552b736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552b736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2552b736')) {
      api.createRecord('2552b736', component.options)
    } else {
      api.reload('2552b736', component.options)
    }
    module.hot.accept("./cardList2.vue?vue&type=template&id=2552b736&scoped=true", function () {
      api.rerender('2552b736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/components/cardList2.vue"
export default component.exports